import { RouteObject } from "react-router-dom";
import { authRoutes } from "./auth-route";

export const publicRoutes: RouteObject[] = [...authRoutes];
